export default __webpack_public_path__ + "static/media/FB_CreateApp.cc4a5b27.png";